export enum AdStatus {
  Opened = 'opened',
  Pending = 'pending',
  Actualized = 'actualized',
  Expired = 'expired',
}
